module.exports = __webpack_public_path__ + "img/材料力学5_9.99342bd3.jpg";